import React from "react";

export default function Market() {
  return (
    <section data-testid="market-section" className="py-24 md:py-32 bg-[#2B211A] text-[#EFEBE4] relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1621109246687-10ae613f2d8e?auto=format&fit=crop&w=1900&q=70')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="grain" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="grid lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <span className="text-xs uppercase tracking-[0.28em] text-[#B89A7E]">Specialisation</span>
            <h2 className="font-serif-display mt-6 text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-[#F9F8F6] leading-[1.05]">
              A narrow practice for a <span className="italic text-[#B89A7E]">narrow client</span>.
            </h2>
            <p className="mt-7 text-[#D6CDBB] text-lg leading-relaxed max-w-2xl font-light">
              Dira Yanuar Rusdias LLC works exclusively with high-net-worth individuals, overseas private landlords,
              and boutique offshore syndicates holding prime urban residential property in the
              world&rsquo;s densest financial corridors. Our initial centre of gravity is{" "}
              <span className="text-[#F9F8F6]">Soho, London (W1D)</span>.
            </p>
          </div>

          <div className="lg:col-span-5">
            <div className="grid grid-cols-2 gap-px bg-[#6B5343]/40 border border-[#6B5343]/40">
              <Stat label="Primary focus" value="London" sub="W1, SW1, SW3, NW3" />
              <Stat label="Asset class" value="Prime residential" sub="Single units → 8-unit blocks" />
              <Stat label="Typical mandate" value="£1.2M – £15M" sub="Single asset value" />
              <Stat label="Client geography" value="6 continents" sub="Absentee owners only" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ label, value, sub }) {
  return (
    <div className="bg-[#2B211A] p-8">
      <div className="text-[11px] uppercase tracking-[0.28em] text-[#B89A7E]">{label}</div>
      <div className="font-serif-display text-3xl md:text-4xl text-[#F9F8F6] mt-3 leading-tight">
        {value}
      </div>
      <div className="text-sm text-[#D6CDBB]/70 mt-2 font-light">{sub}</div>
    </div>
  );
}
